import { Link } from "react-router-dom";

// A pill/architectural button used across the site.
// variant: "gold" | "ghost" | "line"
export default function GoldButton({
  as = "link",
  to,
  href,
  onClick,
  children,
  variant = "gold",
  className = "",
  testId,
  type,
  ...rest
}) {
  const base =
    "group relative inline-flex items-center gap-3 rounded-full px-6 py-3 font-sans text-[12px] uppercase tracking-widest transition-colors duration-300";
  const variants = {
    gold:
      "bg-gold text-ink-950 border border-gold hover:bg-transparent hover:text-gold",
    ghost:
      "bg-transparent text-ivory border border-ivory/20 hover:bg-ivory hover:text-ink-950",
    line: "bg-transparent text-gold border border-gold hover:bg-gold hover:text-ink-950",
  };
  const cls = `${base} ${variants[variant]} ${className}`;

  const inner = (
    <>
      <span className="relative z-10">{children}</span>
      <span
        aria-hidden
        className="relative z-10 h-px w-6 bg-current transition-all duration-300 group-hover:w-9"
      />
    </>
  );

  if (as === "a" && href) {
    return (
      <a
        href={href}
        className={cls}
        data-testid={testId}
        onClick={onClick}
        target={rest.target}
        rel={rest.rel}
      >
        {inner}
      </a>
    );
  }
  if (as === "button" || onClick || type) {
    return (
      <button className={cls} data-testid={testId} onClick={onClick} type={type || "button"}>
        {inner}
      </button>
    );
  }
  return (
    <Link to={to || "/"} className={cls} data-testid={testId}>
      {inner}
    </Link>
  );
}
